import type { TOC } from '@ember/component/template-only';
interface DividerSignature {
  Args: {
    orientation?: 'horizontal' | 'vertical';
  };
  Element: HTMLHRElement | HTMLDivElement;
}

const Divider: TOC<DividerSignature> = <template>
  {{#if (eq @orientation "vertical")}}
    <div
      role="separator"
      aria-orientation="vertical"
      data-test-id="divider"
      class="self-stretch border-0 border-l tio-border-default"
      ...attributes
    />
  {{else}}
    <hr data-test-id="divider" class="border-0 border-t tio-border-default" ...attributes />
  {{/if}}
</template>;

export default Divider;
